import React from 'react';

function TextAreaComponent(props) {

    return (
        <div className="form-group bmd-form-group">
            <label className="text-dark bmd-label-static">{props.label}</label>
            <textarea
                className={props.object.isValid ? "form-control" : "form-control is-invalid"}
                name={props.name}
                onChange={props.inputChangeHandler}
                placeholder={props.placeholder}
                rows={props.rows? props.rows : 4}
                value={props.object.value}
            />
            <small className="form-text text-danger">{props.object.message}</small>
        </div>
    )
}

export default TextAreaComponent;


// WEBPACK FOOTER //
// ./src/components/TextAreaComponent/TextAreaComponent.jsx